import { IIntroductionLinkProps } from '../components/home-components/instruction-link';
import { authLoaded } from '../store';

export const homePageInstructionsWeb2 = [
  {
    name: 'GO LIVE TO APP (CLOSED, PUBLIC GROUP NOTES)',
    pdfUrl: '/documents/web/Go Live to App (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
  {
    name: 'FIND AND FOLLOW A LEADER',
    pdfUrl: '/documents/web/Find and Follow a Leader (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
  {
    name: 'COPY LEADER POSTS TO LIBRARY',
    pdfUrl: '/documents/web/Copy Leader Posts to Library (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
  {
    name: 'VIEW LIBRARY, ADD AFFIRMATIONS',
    pdfUrl: '/documents/web/View Library and Add Affirmations (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
  {
    name: 'SHARE LEADER POSTS',
    pdfUrl: '/documents/web/Find and Follow a Leader (WEB).pdf',
    videoUrl: '',
    breakpoint: undefined,
  },
];
